/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Last_ExportedInputs */

const cs_portals_last_exported = /** @type {(inputs: Portals_Last_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední export`)
};

const en_portals_last_exported = /** @type {(inputs: Portals_Last_ExportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last exported`)
};

/**
* | output |
* | --- |
* | "Last exported" |
*
* @param {Portals_Last_ExportedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_last_exported = /** @type {((inputs?: Portals_Last_ExportedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Last_ExportedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_last_exported(inputs)
	return cs_portals_last_exported(inputs)
});